import React from 'react'
import fixxinvest from '../Assets/logo-fixxinvest.webp'
import phone from '../Assets/phone2.webp'
import '../Styles/Home.css'
import '../Styles/FixxinvestSection.css'
import Introduction from '../Components/Introduction'
import CardServices from '../Components/CardServices'
import MarketAnalysis from '../Components/MarketAnalysis'
import CardPortfolio from '../Components/CardPortfolio'
import logoCVM from '../Assets/logo-cvm.webp'
import market from '../Assets/market.svg'
import farm from '../Assets/farm.svg'
import industry from '../Assets/industry.svg'
import sede from '../Assets/sede-fixxinvest.webm'

const Fixxinvest = ({ id }) => {
  return (
    <section id={id}>
      <div className="video-background flex-center full-window">
        <video autoPlay loop muted className="background-video">
          <source src={sede} type="video/mp4" />
          Seu navegador não suporta o vídeo.
        </video>
        <div className="content">
          <Introduction
            srcLogo={fixxinvest}
            altLogo="Fixxinvest"
            description={
              <>
                A <span>Fixxinvest S/A</span>, inscrita sob o{' '}
                <span>CNPJ 36.362.607/0001-69</span>, destaca-se no cenário
                nacional como uma administradora de bens e gestora de
                patrimônio, com expertise nos mercados financeiro e imobiliário.
                Com uma abordagem personalizada, a empresa se dedica a
                compreender o perfil de cada cliente, oferecendo soluções
                transparentes e seguras para a administração e alocação de
                ativos.
              </>
            }
            color="white"
            img={true}
            srcProduct={phone}
            altProduct="Aplicativo Fixxinvest"
          />
          <div id="container-cvm" className="flex-center flex__gap-20">
            <p>CVM 000116-3</p>
            <a
              href="https://www.gov.br/cvm/pt-br"
              target="_blank"
              rel="noreferrer"
            >
              <div className="cvm-logo">
                <img src={logoCVM} alt="Logo CVM" />
              </div>
            </a>
          </div>
        </div>
      </div>

      <div
        className="sections flex-center flex-column flex__gap-100"
        id="introduction-fixxinvest"
      >
        <h2 className="title-main text-white">
          <span>Rentabilidade</span> das Carteiras
        </h2>
        <div
          id="container-cards-portfolio"
          className="flex-center flex-wrap flex__gap-50"
        >
          <CardPortfolio
            title="Carteira Multimercados"
            description="Rentabilidade variável de 0% a 1.3%."
            img={market}
            altImg="multimercados"
          />
          <CardPortfolio
            title="Carteira Agro"
            description="Rentabilidade variável de 1.3% a 1.5%"
            img={farm}
            altImg="Agronegócio"
          />
          <CardPortfolio
            title="Carteira Industria e Imobiliária"
            description="Rentabilidade variável de 1.5% a 1.8% "
            img={industry}
            altImg="Indústria"
          />
        </div>
      </div>
      <div
        className="flex-center flex-column flex__gap-50 padding-100 background-light"
        id="service-realstate"
      >
        <h1 className="title-main text-white">Serviço Imobiliário</h1>
        <div className="flex-center flex__gap-50 flex__wrap">
          <CardServices
            title="Real State e Construção Civil Itapema"
            description="Em parceria com a construtora HKnouve Group, a Fixxinvest participa da construção de um prédio de 33 pavimentos, um marco que reflete o compromisso com projetos de alta qualidade e planejamento estratégico."
            backgroundColor="white"
            height="260px"
          />
          <CardServices
            title="Lotus Business - Itapema"
            description="O Lotus Business, em Itapema, é um empreendimento moderno e sofisticado, projetado para atender às mais altas exigências. Com infraestrutura de ponta e localização privilegiada, oferece o equilíbrio perfeito entre funcionalidade e estilo, sendo ideal para empresas que buscam crescer com qualidade."
            backgroundColor="white"
            height="260px"
          />
          <CardServices
            title="Atuação Nacional"
            description="A Fixxinvest possui alocações estratégicas de norte a sul do país, com foco em Equity de médio e longo prazo. A abordagem conta com um enfoque para projetos de incorporação, leilão e aquisição de estoque."
            backgroundColor="white"
            height="260px"
          />
        </div>
      </div>
      <div
        className="flex-center flex-column flex__gap-50 padding-100 background-light"
        id="service-construction"
      >
        <h1 className="title-main text-white">Construção Civil</h1>
        <div className="flex-center flex__gap-50 flex__wrap">
          <CardServices
            title="Construção em Alphaville/SP"
            description={
              <>
                Casas de alto padrão nos condomínios:
                <br />
                Tamboré 2, Tamboré 3, Residencial 1, Residencial 2.
                Representando um investimento total de 32 milhões, um testemunho
                de nosso sucesso e liderança no setor.
              </>
            }
            backgroundColor="white"
            height="260px"
          />
        </div>
      </div>
      <div
        className="flex-center flex-column flex__gap-50 padding-100 background-light"
        id="service-auction"
      >
        <h1 className="title-main text-white">Leilão</h1>
        <div className="flex-center flex__gap-50 flex__wrap">
          <CardServices
            title="Aquisição de Estoques"
            description="Em 2023, a Fixxinvest adquiriu mais de 11 milhões em estoques inteiros da Receita Federal, provando sua habilidade em identificar e capitalizar oportunidades no mercado."
            backgroundColor="white"
            height="260px"
          />
          <CardServices
            title="Leilão de Soja"
            description="Nossa expertise no mercado de leilões, especialmente na compra e venda de soja, resultou em transações que ultrapassam os 19 milhões, comprovando nossa capacidade de movimentar grandes volumes com eficácia."
            backgroundColor="white"
            height="260px"
          />
        </div>
      </div>
      <MarketAnalysis
        description={
          <>
            A Fixxinvest S/A{' '}
            <span>
              se destaca por sua capacidade estratégica em um mercado volátil e
              imprevisível
            </span>
            . Com a inflação em alta e as taxas de juros experimentando
            variações significativas, a habilidade da empresa em adaptar
            rapidamente suas tecnologias torna-se um diferencial competitivo.{' '}
            <br />
            <br /> A Fixxinvest permite identificar oportunidades emergentes,
            especialmente em setores menos sensíveis às flutuações econômicas,
            como o imobiliário e o tecnológico. Além disso, a crescente demanda
            por alocações sustentáveis abre novos horizontes para a empresa, que
            pode capitalizar sobre as mesmas,{' '}
            <span>
              {' '}
              diversificando ainda mais seu portfólio e fortalecendo sua posição
              no mercado
            </span>
            . <br />
            <br /> A proatividade da Fixxinvest em antecipar tendências e
            adaptar-se às mudanças do mercado não apenas protege os ativos de
            seus clientes, mas também posiciona a empresa como líder em inovação
            e gestão patrimonial nacionalmente.
            <br />
            <br />
            Nossa dedicação à inovação, aliada a uma estratégia sólida e um
            profundo conhecimento do mercado assegura a melhor performance para
            as alocações de nossos clientes. Convidamos você a explorar como{' '}
            <span>
              a Fixxinvest pode transformar a gestão do seu patrimônio
            </span>
            .
          </>
        }
        backgroundColor="white"
        colorTitle="#090A0A"
        colorContent="#706d7e"
        colorSvg="#090A0A"
      />
    </section>
  )
}

export default Fixxinvest
